import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const MeetingUpdateNoticeCover = ({ notification, sender }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={rtl ? 'تعديل اجتماع' : 'Meeting modification'}
    />
  )
}

export default MeetingUpdateNoticeCover
